import React, {useState, useEffect} from 'react';
import './ClubCalendrier.css';

import { apiLink, URL_WS_URL } from '../variables';

import axios from 'axios';
import Match from './Match';

function ClubCalendrier({championnat, club}) {
    const [matchs, setMatchs] = useState([]);
    const [livescoringMatchs, setLivescoringMatchs] = useState([]);
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        // on récupère les matchs
        getMatchs();
        getLivescoringMatchs();
    }, [championnat]);

    const getMatchs = async () => {
        const link = apiLink.find(item => item.for === championnat).link;
        if (link !== '') {
            axios
            .get(link, {
                "Content-Type": "application/xml; charset=utf-8"
            })
            .then(function(res) {
                setMatchs(res.data);
                setLoaded(true);
            })
            .catch(function(error) {
                console.log(error);
                setLoaded(true);
            });
        } 
    }

    const getLivescoringMatchs = async () => {
        const link = URL_WS_URL + "/livescore/all_livescores";
        axios
        .get(link, {
            "Content-Type": "application/xml; charset=utf-8"
        })
        .then(function(res) {
            var data = res.data;
            setLivescoringMatchs(data)
        })
        .catch(function(error) {
            console.log(error);
        });
    }


    const getHeaderLivescore = (renc_id) => {
        let headerLivescore = {};
        if (livescoringMatchs !== null && livescoringMatchs !== undefined) {
            if (livescoringMatchs.list !== undefined) {
                for (const div of livescoringMatchs.list) {
                    // S'il y a des matchs dans la div alors on regarde s'il y a le match qu'on veut
                    const match = div.matchs.find(item => item.renc_id === renc_id);
                    if (match !== undefined) {
                        headerLivescore = match;
                        break; // Sort complètement de la boucle externe
                    }
                }
            }
        }
        return headerLivescore;
    }

    const info = (index, value) => {
        return matchs[index][value];
    }

    const getRencID = (index) => {
        const cData = matchs[index].lien;
        const rencID = cData.split('renc_id=')[1].split('&')[0];
        return rencID;
    }

    const getEquipe1Num = (index) => {
        const cData = matchs[index].lien;
        const num = cData.split('clubnum_1=')[1].split('&')[0];
        return num;
    }

    const getEquipe2Num = (index) => {
        const cData = matchs[index].lien;
        const num = cData.split('clubnum_2=')[1].split(' ')[0];
        return num;
    }

    const getDayMatch = (index) => {
        let tour = matchs[index].libelle.toString();
        tour = tour.split('°')[1].split(' ')[0];
        return parseInt(tour);
    }

    const isHome = (index) => getEquipe1Num(index) === club.identifier || info(index, 'equa') === club.title.toUpperCase();
    const isAway = (index) => getEquipe2Num(index) === club.identifier || info(index, 'equb') === club.title.toUpperCase();
    const hasScore = (item) => item.scorea !== undefined && item.scorea !== '' && item.scoreb !== undefined && item.scoreb !== '';

    // Rencontres du club, avec leur index dans la liste complète (utilisé par les getters)
    const clubMatchs = Array.isArray(matchs)
        ? matchs.map((item, index) => ({item, index})).filter(({index}) => isHome(index) || isAway(index))
        : [];
    const aVenir = clubMatchs.filter(({item}) => !hasScore(item));
    const resultats = clubMatchs.filter(({item}) => hasScore(item));

    // Bilan calculé sur les scores officiels
    const bilan = resultats.reduce((acc, {item, index}) => {
        const scoreClub = parseInt(isHome(index) ? item.scorea : item.scoreb);
        const scoreAdv = parseInt(isHome(index) ? item.scoreb : item.scorea);
        if (scoreClub > scoreAdv) acc.victoires++;
        else if (scoreClub < scoreAdv) acc.defaites++;
        else acc.nuls++;
        return acc;
    }, {victoires: 0, defaites: 0, nuls: 0});

    const prochain = aVenir[0];
    const getAdversaire = ({item, index}) => isHome(index) ? item.equb : item.equa;
    const getDateCourte = (value) => {
        const [d, m, y] = (value || '').split('/');
        const date = new Date(y + '-' + m + '-' + d);
        return isNaN(date.getTime()) ? value : date.toLocaleDateString('fr-FR', {day: 'numeric', month: 'short'});
    }

    const renderMatch = ({item, index}) => (
        <Match
            key={getRencID(index)}
            championnat={championnat}
            match={item}
            currentClub={club}
            headerLivescore={getHeaderLivescore(getRencID(index))}
            currentDay={getDayMatch(index)}
            variant="club"
        />
    );

    return (
        <div className={"club_calendrier_component " + championnat}>
            {
                clubMatchs.length > 0 &&
                <div className="club_calendrier_bilan">
                    <div className="club_calendrier_stat">
                        <span className="club_calendrier_stat_label">Joués</span>
                        <span className="club_calendrier_stat_value">{resultats.length}</span>
                    </div>
                    <div className="club_calendrier_stat win">
                        <span className="club_calendrier_stat_label">Victoires</span>
                        <span className="club_calendrier_stat_value">{bilan.victoires}</span>
                    </div>
                    <div className="club_calendrier_stat loss">
                        <span className="club_calendrier_stat_label">Défaites</span>
                        <span className="club_calendrier_stat_value">{bilan.defaites}</span>
                    </div>
                    {
                        bilan.nuls > 0 &&
                        <div className="club_calendrier_stat">
                            <span className="club_calendrier_stat_label">Nuls</span>
                            <span className="club_calendrier_stat_value">{bilan.nuls}</span>
                        </div>
                    }
                    <div className="club_calendrier_stat club_calendrier_stat_next">
                        <span className="club_calendrier_stat_label">Prochain match</span>
                        {
                            (prochain &&
                            <span className="club_calendrier_stat_next_value">
                                <span>
                                    <strong>{getDateCourte(prochain.item.datereelle)}</strong>
                                    {prochain.item.heurereelle ? " · " + prochain.item.heurereelle : ""}
                                </span>
                                <span className="club_calendrier_stat_next_vs">
                                    {isHome(prochain.index) ? "Domicile" : "Extérieur"} vs {getAdversaire(prochain)}
                                </span>
                            </span>)
                            ||
                            <span className="club_calendrier_stat_next_value">Saison terminée</span>
                        }
                    </div>
                </div>
            }

            {
                clubMatchs.length > 0 &&
                <section className="club_calendrier_section">
                    <h2 className="club_calendrier_title">Matchs <span>{clubMatchs.length}</span></h2>
                    <div className="match_cards">
                        {clubMatchs.map(renderMatch)}
                    </div>
                </section>
            }

            {
                loaded && clubMatchs.length === 0 &&
                <p className="club_calendrier_empty">Aucune rencontre disponible pour le moment.</p>
            }
        </div>
     );
}

export default ClubCalendrier;